import { render, staticRenderFns } from "./platformProduct.vue?vue&type=template&id=564939ec&scoped=true&"
import script from "./platformProduct.vue?vue&type=script&lang=js&"
export * from "./platformProduct.vue?vue&type=script&lang=js&"
import style0 from "./platformProduct.vue?vue&type=style&index=0&id=564939ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564939ec",
  null
  
)

export default component.exports